import React, {useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import css from 'css';
import CloseIcon from 'images/CloseIcon';
import {
    setBookingProgressCollapsedValue,
    setBookingVisibility,
    resetBookingState,
    setCartCollapsedValue,
    setCheckoutVisibility,
    clearBooking
} from 'store';

const Advisor = (props) => {
    const { visible, meetingType } = props;
    const [loaded, setLoaded] = useState(false);
    const [type, setType] = useState(null);

    useEffect(() => {
        if (!meetingType) return;
        props.setBookingProgressCollapsedValue(true);
        loadIframeFromMeetingType(meetingType);
    },[meetingType]);

    const loadIframeFromMeetingType = (meetingType) => {
        switch(meetingType) {
            case 'Videomøte': 
                setType('videokonferanse');
            break;
            case 'Telefon':
                setType('telefonkonferanse');
            break;
            case 'Fysisk møte':
                setType('fysiskradgivning');
            break;
            case 'Lånekassen':
                setType('');
            break;
            default:
                setType('');
            break;
        }
        setLoaded(true);
    }

    const _closeBooking = () => {
        props.setBookingVisibility(false);
        props.setCartCollapsedValue(true);
        props.resetBookingState();

        props.clearBooking();
        props.setCheckoutVisibility(false);
        props.setCartCollapsedValue(false);
    }

    if(!visible) return null;

    return(
        <Wrapper>
                    <CloseButton onClick={() => _closeBooking()}>
                        <CloseIcon color="black" />
                    </CloseButton>
            { loaded && 
                <StyledIframe
                    src={`https://calendly.com/bjn-external/${type}?embed_type=Inline&embed_domain=${window.location.hostname}`}
                    title="description"
                    sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-storage-access-by-user-activation allow-top-navigation-by-user-activation"
                ></StyledIframe>
            }
        </Wrapper>
    )
}

const mapStateToProps = state => ({
    visible: state.bookMeeting.visible,
    meetingType: state.bookMeeting.meetingType,
    booking: state.bookMeeting,
});

const actions = {
    setBookingProgressCollapsedValue,
    setBookingVisibility,
    resetBookingState,
    setCartCollapsedValue,
    setCheckoutVisibility,
    clearBooking
};

export default connect(mapStateToProps, actions)(Advisor);

const Wrapper = styled.div`
    position: fixed;
    z-index: 999;
    width:100%;
    height: 100vh;
    top:0;
    left:0;
    background: ${css.colors.blue};
    overflow-y:auto;
    overflow-x: hidden;

    @media(max-width: 767px) {
        height: 100svh;
    }
`;

const StyledIframe = styled.iframe`
    position: relative;
    width: 100%;
    height: 100%;
`;

const CloseButton = styled.button`
    position: fixed;
    top: 40px;
    right: 40px;
    cursor: pointer;
    z-index: 9999;

`


// WEBPACK FOOTER //
// ./src/partials/Calendly/Advisor.js